// extracted by mini-css-extract-plugin
export default {"labelText":"_1ZL3r___labels-module__labelText"};